//src/components/Signup.js

import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import { firebaseSignup } from "./apiService";
import "../Signup.css";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError(""); //clear any previous errors

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // Send user information to your server
      const response = await firebaseSignup({
        email: user.email,
        uid: user.uid,
      });

      setEmail("");
      setPassword("");
      navigate("/");
    } catch (error) {
      console.error("Error signing up:", error);
      setError("Failed to sign up. Please check your details and try again");
    }
  };

  return (
    <div className="signup-container">
      <h3 className="signup-title">
        <u>Signup</u>
      </h3>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSignup} className="signup-form">
        <input
          className="input-field mb-4"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <br />
        <input
          className="input-field mb-4"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <br />
        <button className="btn btn-success mb-4" type="submit">
          Signup
        </button>
      </form>
    </div>
  );
};

export default Signup;
